import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsDateString,
  IsOptional,
  IsString,
  IsUUID,
  MaxLength,
  ValidateNested,
} from 'class-validator';
import { JobRepairBuilderSupervisorBatchDto } from '../../job-repair-builder-supervisor/dto/job-repair-builder-supervisor-batch.dto';
import { RepairPaymentCreateDto } from '../../repair-payment/dto/repair-payment-create.dto';
import {
  JobRepairPhotoItemDto,
  PHOTO_BATCH_MAX_ITEMS,
} from '../../job-repair-photo/dto/job-repair-photo-item.dto';

export class RepairPaymentEditBatchDto {
  @ApiPropertyOptional({ type: () => [RepairPaymentCreateDto] })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RepairPaymentCreateDto)
  insert?: RepairPaymentCreateDto[];

  @ApiPropertyOptional({ type: [String], format: 'uuid' })
  @Expose()
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  delete?: string[];
}

/**
 * Body of PATCH /job-repair/:id/edit-batch: everything the repair edit dialog
 * saves, in one transaction. Omitted keys are left untouched.
 */
export class JobRepairEditBatchDto {
  @ApiPropertyOptional({ type: 'string', format: 'date-time' })
  @Expose()
  @IsOptional()
  @IsDateString()
  repairDate?: string;

  @ApiPropertyOptional({ type: () => JobRepairBuilderSupervisorBatchDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => JobRepairBuilderSupervisorBatchDto)
  subdivisionBuilderSupervisor?: JobRepairBuilderSupervisorBatchDto;

  @ApiPropertyOptional({ type: () => RepairPaymentEditBatchDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => RepairPaymentEditBatchDto)
  repairPayments?: RepairPaymentEditBatchDto;

  @ApiPropertyOptional({
    type: 'string',
    description:
      'New DESCRIPTION note; recorded only when it differs from the current one.',
  })
  @Expose()
  @IsOptional()
  @IsString()
  @MaxLength(5000)
  descriptionNote?: string;

  @ApiPropertyOptional({ type: () => [JobRepairPhotoItemDto] })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(PHOTO_BATCH_MAX_ITEMS)
  @ValidateNested({ each: true })
  @Type(() => JobRepairPhotoItemDto)
  photos?: JobRepairPhotoItemDto[];
}
